import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSearchFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 1.176a8 8 0 0 1 6.47 12.702l4.914 4.914a1.25 1.25 0 0 1-1.768 1.768l-4.914-4.914A8 8 0 1 1 10 1.175m0 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11",
    clipRule: "evenodd"
  }));
}
var IcSearchFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSearchFill));

export { IcSearchFill as I };
